import React, { useEffect } from 'react';

import leadsActions from 'actions/leads';
import LeadsToolbar from './subcomponents/LeadsToolbar';
import LeadsTable from './subcomponents/LeadsTable';

import {
    KEY_CREATED, KEY_TOTAL_COST, KEY_CREATED_BY, KEY_OWNER_ID,
    KEY_ACQUISITION_COST, KEY_LAST_MODIFIED, KEY_PRODUCT_INTEREST,
    KEY_ADDITIONAL_COST, KEY_LAST_MODIFIED_BY, KEY_LEAD_PRIORITY,
    KEY_EXPECTED_REVENUE, KEY_LEAD_ID, KEY_LEAD_SCORE, KEY_CONVERT,
    KEY_CONTACT_NAME, KEY_LEAD_RATING, KEY_ACTIONS, KEY_ACCOUNT,
    KEY_MASTER_SECONDARY, KEY_STAGE, KEY_CAMPAIGN_SOURCE, KEY_LOST_REASON,
    KEY_CLOSE_PROBABILITY,
    KEY_OUTCOME,
    KEY_CO_OWNER
} from 'shared/constants/MODULE_COLUMNS';
import contactsActions from 'actions/contacts';
import ModulesListView from 'shared/ModulesListView';
import { useDispatch } from 'react-redux';
import BulkActionsProvider from 'shared/context/BulkActionsProvider';

const Leads = () => {
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(contactsActions.getOwnersAndCoOwners({
            list:"lead"
        }))

    }, [dispatch])
    return (
        <BulkActionsProvider>

            <ModulesListView
                TableComponent={LeadsTable}
                ToolbarComponent={LeadsToolbar}
                allowedColumns={[KEY_CREATED, KEY_ACCOUNT, KEY_STAGE, KEY_LEAD_ID, KEY_CONTACT_NAME, KEY_OUTCOME, KEY_LAST_MODIFIED, KEY_OWNER_ID, KEY_CO_OWNER, KEY_CREATED_BY, KEY_LAST_MODIFIED_BY, KEY_MASTER_SECONDARY, KEY_PRODUCT_INTEREST, KEY_LEAD_PRIORITY, KEY_LEAD_RATING, KEY_LEAD_SCORE]}
                defaultColumnsDisplayed={[
                    KEY_CREATED,
                    KEY_LEAD_ID,
                    KEY_OUTCOME,
                    KEY_ACCOUNT,
                    KEY_STAGE,
                    KEY_CONVERT,
                    KEY_ACTIONS
                ]}
                moduleName='Leads'
                readModules={leadsActions.readLeads}
                routeRoot={'leads'}
                columnDisplayOptions={[
                    KEY_CREATED, KEY_TOTAL_COST, KEY_CREATED_BY, KEY_OWNER_ID, KEY_CO_OWNER,
                    KEY_ACQUISITION_COST, KEY_LAST_MODIFIED, KEY_PRODUCT_INTEREST,
                    KEY_ADDITIONAL_COST, KEY_LAST_MODIFIED_BY, KEY_LEAD_PRIORITY,
                    KEY_EXPECTED_REVENUE, KEY_LEAD_ID, KEY_LEAD_SCORE, KEY_CONVERT,
                    KEY_CONTACT_NAME, KEY_LEAD_RATING, KEY_ACTIONS, KEY_ACCOUNT,
                    KEY_MASTER_SECONDARY, KEY_STAGE, KEY_CAMPAIGN_SOURCE, KEY_LOST_REASON,
                    KEY_CLOSE_PROBABILITY,
                    KEY_OUTCOME
                ]}
            />
        </BulkActionsProvider>
    );
}

export default Leads;
